module.exports = __webpack_public_path__ + "static/media/addTeam.4cfd934e.svg";